import React from 'react';
import _ from 'lodash';
import { Row, Col, List } from 'antd';

import _s from './index.less';

const Carousel = ({ ListItem, items = [], title, count, column = 3 }) => {
  if (!_.isNumber(count)) count = items.length;

  return (
    <Row style={{ paddingLeft: 16, paddingRight: 16 }}>
      <Col span={24}>
        <Row>
          <Col span={24}>
            <span className={_s.block_title}>{title}</span>
          </Col>
        </Row>
        <Row>
          <List
            grid={{
              gutter: 16,
              lg: column,
              xl: column,
              xxl: column,
              md: column - 1 < 2 ? 1 : column - 1,
              sm: 1,
              xs: 1
            }}
            dataSource={[].concat(items).slice(0, count)}
            renderItem={item => (
              <List.Item style={{ marginBottom: 16, cursor: 'pointer' }}>
                <ListItem item={item} />
              </List.Item>
            )}
          />
        </Row>
      </Col>
    </Row>
  );
};

export default Carousel;
